export default __webpack_public_path__ + "static/media/gabriella_alagha.441a4633.png";